/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminCoach,
  AdminV1OrganizationsCoachesListParams,
  PaginatedLightweightAdminCoachList,
  PatchedAdminCoach
} from '.././model';

import adminV1OrganizationsCoachesListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsCoachesCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsCoachesRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsCoachesUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsCoachesPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsCoachesDestroyMutator from '../../shared/services/axios-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsCoachesList = (
    organizationId: number,
    params?: AdminV1OrganizationsCoachesListParams,
 options?: SecondParameter<typeof adminV1OrganizationsCoachesListMutator<PaginatedLightweightAdminCoachList>>,) => {
      return adminV1OrganizationsCoachesListMutator<PaginatedLightweightAdminCoachList>(
      {url: `/api/admin/v1/organizations/${organizationId}/coaches/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsCoachesCreate = (
    organizationId: number,
    adminCoach: NonReadonly<AdminCoach>,
 options?: SecondParameter<typeof adminV1OrganizationsCoachesCreateMutator<AdminCoach>>,) => {
      return adminV1OrganizationsCoachesCreateMutator<AdminCoach>(
      {url: `/api/admin/v1/organizations/${organizationId}/coaches/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminCoach
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsCoachesRetrieve = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsCoachesRetrieveMutator<AdminCoach>>,) => {
      return adminV1OrganizationsCoachesRetrieveMutator<AdminCoach>(
      {url: `/api/admin/v1/organizations/${organizationId}/coaches/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsCoachesUpdate = (
    organizationId: number,
    id: number,
    adminCoach: NonReadonly<AdminCoach>,
 options?: SecondParameter<typeof adminV1OrganizationsCoachesUpdateMutator<AdminCoach>>,) => {
      return adminV1OrganizationsCoachesUpdateMutator<AdminCoach>(
      {url: `/api/admin/v1/organizations/${organizationId}/coaches/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminCoach
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsCoachesPartialUpdate = (
    organizationId: number,
    id: number,
    patchedAdminCoach: NonReadonly<PatchedAdminCoach>,
 options?: SecondParameter<typeof adminV1OrganizationsCoachesPartialUpdateMutator<AdminCoach>>,) => {
      return adminV1OrganizationsCoachesPartialUpdateMutator<AdminCoach>(
      {url: `/api/admin/v1/organizations/${organizationId}/coaches/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminCoach
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsCoachesDestroy = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsCoachesDestroyMutator<void>>,) => {
      return adminV1OrganizationsCoachesDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/coaches/${id}/`, method: 'DELETE'
    },
      options);
    }
  export type AdminV1OrganizationsCoachesListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsCoachesList>>>
export type AdminV1OrganizationsCoachesCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsCoachesCreate>>>
export type AdminV1OrganizationsCoachesRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsCoachesRetrieve>>>
export type AdminV1OrganizationsCoachesUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsCoachesUpdate>>>
export type AdminV1OrganizationsCoachesPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsCoachesPartialUpdate>>>
export type AdminV1OrganizationsCoachesDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsCoachesDestroy>>>
